export default __webpack_public_path__ + "static/media/portadavideoanalisis2.a6edb417.png";